export default "__VITE_ASSET__fpEi$MbV__"